export enum EHomePopupKey {
    AGREEMENT_SIGN = 'AGREEMENT_SIGN',
    FIRST_LOGIN = 'FIRST_LOGIN',
    ASK_CHART_WELCOME = 'ASK_CHART_WELCOME',
    INSURANCE_SURVEY = 'INSURANCE_SURVEY',
    CREATE_UNIPROFILE = 'CREATE_UNIPROFILE',
    SERVICE_AVAILABILITY = 'SERVICE_AVAILABILITY',
    OPT_CHANNEL = 'OPT_CHANNEL',
    PAYMENTS = 'PAYMENTS',
    CALENDLY = 'CALENDLY',
    WEBINAR = 'WEBINAR',
    PRESCRIPTION_CONFIG = 'PRESCRIPTION_CONFIG',
    HOME_TOUR = 'HOME_TOUR',
    KLARITY_HOME_TOUR = 'KLARITY_HOME_TOUR',
    TERMS_UPDATE = 'TERMS_UPDATE',
}

export type HomePopupConfig = {
    key: EHomePopupKey;
    priority: number;
    description: string;
    newUser: boolean;
    existingUser: boolean;
    trigger: string;
    file: string;
};

/**
 * priority 越小优先级越高，同时只展示优先级最高的满足条件的弹窗
 *
 * P0-P1 为 Tour，优先级最高，用户走完 Tour 后才展示其他弹窗
 * P2-P12 为 blocking modal，互斥，同时只展示一个
 * Alert（PAYMENT_TIPS）不在此列，独立控制
 */
export const HOME_POPUP_PRIORITY: HomePopupConfig[] = [
    {
        key: EHomePopupKey.KLARITY_HOME_TOUR,
        priority: 0,
        description: 'Klarity Home Tour（11 步 sidebar 引导）',
        newUser: true,
        existingUser: false,
        trigger: '!localStorage.KLARITY_HOME_TOUR_ISOPEN',
        file: 'src/pages/PPALayout/index.tsx',
    },
    {
        key: EHomePopupKey.HOME_TOUR,
        priority: 1,
        description: 'Home Tour 引导（非 Klarity 用户，6 步）',
        newUser: true,
        existingUser: false,
        trigger: '!localStorage.HOME_TOUR_ISOPEN && !isKlarity',
        file: 'src/pages/dashboard/ProviderHomePage/components/GrowthHub/index.tsx',
    },
    {
        key: EHomePopupKey.AGREEMENT_SIGN,
        priority: 2,
        description: '协议签署弹窗（法律强制）',
        newUser: true,
        existingUser: true,
        trigger: 'agreementReviewTypeList.length > 0',
        file: 'src/pages/dashboard/ProviderHomePage/index.tsx',
    },
    {
        key: EHomePopupKey.FIRST_LOGIN,
        priority: 3,
        description: '首次登录引导（2 步欢迎 flow）',
        newUser: true,
        existingUser: false,
        trigger: '!firstLoginAt',
        file: 'src/pages/dashboard/ProviderHomePage/index.tsx',
    },
    {
        key: EHomePopupKey.ASK_CHART_WELCOME,
        priority: 4,
        description: 'AskChart 欢迎弹窗（2026-05-19 新上）',
        newUser: true,
        existingUser: true,
        trigger: '!getHasCloseAskChartWelcomeModal()',
        file: 'src/pages/dashboard/ProviderHomePage/components/GrowthHub/index.tsx',
    },
    {
        key: EHomePopupKey.INSURANCE_SURVEY,
        priority: 5,
        description: 'Insurance Survey 弹窗（已有保险的 provider）',
        newUser: false,
        existingUser: true,
        trigger: '!getHasDismissInsuranceSurveyModal() && existingInsuranceProvider',
        file: 'src/pages/dashboard/ProviderHomePage/index.tsx',
    },
    {
        key: EHomePopupKey.CREATE_UNIPROFILE,
        priority: 6,
        description: 'Create UniProfile 引导',
        newUser: true,
        existingUser: true,
        trigger: '未提交 uniprofile',
        file: 'src/pages/dashboard/ProviderHomePage/index.tsx',
    },
    {
        key: EHomePopupKey.SERVICE_AVAILABILITY,
        priority: 7,
        description: 'Service & Availability 设置引导',
        newUser: true,
        existingUser: true,
        trigger: '服务/可用时间未设置',
        file: 'src/pages/dashboard/ProviderHomePage/index.tsx',
    },
    {
        key: EHomePopupKey.OPT_CHANNEL,
        priority: 8,
        description: 'Opt Channel 引导',
        newUser: true,
        existingUser: true,
        trigger: '!isPPAProvider',
        file: 'src/pages/dashboard/ProviderHomePage/index.tsx',
    },
    {
        key: EHomePopupKey.PAYMENTS,
        priority: 9,
        description: 'Payments 设置引导',
        newUser: true,
        existingUser: true,
        trigger: '!practiceAndPaymentSetUpCompleted',
        file: 'src/pages/dashboard/ProviderHomePage/index.tsx',
    },
    {
        key: EHomePopupKey.CALENDLY,
        priority: 10,
        description: 'Calendly 预约弹窗',
        newUser: true,
        existingUser: false,
        trigger: '!isKlarity && showOnboardingCalendlyPopup',
        file: 'src/pages/dashboard/ProviderHomePage/index.tsx',
    },
    {
        key: EHomePopupKey.WEBINAR,
        priority: 11,
        description: 'Webinar Booking 弹窗',
        newUser: true,
        existingUser: false,
        trigger: '根据 onboarding 阶段',
        file: 'src/pages/dashboard/ProviderHomePage/index.tsx',
    },
    {
        key: EHomePopupKey.PRESCRIPTION_CONFIG,
        priority: 12,
        description: '处方配置弹窗（进入处方页才触发）',
        newUser: false,
        existingUser: true,
        trigger: 'showPrescriptionConfigModal',
        file: 'src/pages/dashboard/ProviderHomePage/components/GrowthHub/index.tsx',
    },
    {
        key: EHomePopupKey.TERMS_UPDATE,
        priority: 13,
        description: 'Provider terms update reminder (credentialing & billing terms)',
        newUser: true,
        existingUser: true,
        trigger: 'termsUpdatePending (API TBD)',
        file: 'src/pages/dashboard/ProviderHomePage/index.tsx',
    },
];
